import { Injectable } from '@angular/core';
import { Observable, combineLatest, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetPluginUpdatesCountResponse, SearchResponse } from '../wsp_admin_center_sdk/_internal/objects';
import { AdminCenterService } from '../wsp_admin_center_sdk/admin-center.service';

export interface SummaryData {
  pluginUpdates: number;
  themeUpdates: number;
  coreUpdates: number;
  totalUpdates: number;
}

@Injectable()
export class WordpressSiteService {
  constructor(private adminCenterApiService: AdminCenterService) {}

  list(
    partnerId: string,
    searchTerm: string,
    pluginUpdates: boolean,
    coreUpdates: boolean,
    themeUpdates: boolean,
    multisite: boolean,
    pageSize: number,
    from: number,
  ): Observable<SearchResponse> {
    return this.adminCenterApiService
      .search({
        searchTerm: searchTerm,
        filters: {
          partnerId: partnerId,
          pluginUpdating: pluginUpdates,
          coreUpdating: coreUpdates,
          themeUpdating: themeUpdates,
          multisite: multisite,
        },
        pageSize: pageSize,
        from: from,
      })
      .pipe(catchError((err) => throwError(err)));
  }

  getWordPressPluginUpdateTotalCount(partnerId: string): Observable<number> {
    return this.adminCenterApiService
      .getPluginUpdatesCount(partnerId)
      .pipe(map((resp: GetPluginUpdatesCountResponse) => resp.totalCount || 0));
  }

  getWordPressCoreUpdateTotalCount(partnerId: string): Observable<number> {
    return this.adminCenterApiService
      .search({
        filters: {
          partnerId: partnerId,
          coreUpdating: true,
        },
        pageSize: 10,
      })
      .pipe(
        map((resp: SearchResponse) => resp.totalResults || 0),
        catchError((err) => throwError(err)),
      );
  }

  getWordPressThemeUpdateTotalCount(partnerId: string): Observable<number> {
    return this.adminCenterApiService
      .search({
        filters: {
          partnerId: partnerId,
          themeUpdating: true,
        },
        pageSize: 10,
      })
      .pipe(
        map((resp: SearchResponse) => resp.totalResults || 0),
        catchError((err) => throwError(err)),
      );
  }

  getWordPressSummaryData(partnerId: string): Observable<SummaryData> {
    return combineLatest([
      this.getWordPressPluginUpdateTotalCount(partnerId),
      this.getWordPressThemeUpdateTotalCount(partnerId),
      this.getWordPressCoreUpdateTotalCount(partnerId),
    ]).pipe(
      map(([pluginUpdates, themeUpdates, coreUpdates]: [number, number, number]) => {
        return {
          pluginUpdates: pluginUpdates,
          themeUpdates: themeUpdates,
          coreUpdates: coreUpdates,
          totalUpdates: pluginUpdates + themeUpdates + coreUpdates,
        } as SummaryData;
      }),
      catchError((err) => throwError(err)),
    );
  }
}
